<template>
  <Dialog
    v-model:visible="visibleProxy"
    modal
    append-to="body"
    :closable="false"
    :draggable="false"
    class="w-full max-w-lg"
    data-testid="commitment-done-dialog"
    @hide="resetForm"
  >
    <template #header>
      <div class="flex items-start justify-between gap-3 w-full">
        <div class="min-w-0">
          <h2 class="text-lg font-semibold text-[var(--color-dark)] m-0">
            {{ $t('ProjectManagement.commitments.doneDialog.title') }}
          </h2>
          <p v-if="commitmentLabel" class="text-sm text-[var(--color-disabled)] mt-1 mb-0">
            {{ commitmentLabel }}
          </p>
        </div>
        <button
          type="button"
          class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-[var(--color-disabled)] hover:bg-[#f5f5f5]"
          :aria-label="$t('ProjectManagement.cancel')"
          @click="close"
        >
          <i class="pi pi-times" aria-hidden="true" />
        </button>
      </div>
    </template>

    <p class="text-sm text-[var(--color-disabled)] mt-0 mb-4">
      {{ $t('ProjectManagement.commitments.doneDialog.subtitle') }}
    </p>

    <label class="flex flex-col gap-1 text-sm">
      <span class="font-medium">{{ $t('ProjectManagement.commitments.doneDialog.commentLabel') }}</span>
      <Textarea
        v-model="comment"
        rows="3"
        class="w-full"
        :maxlength="maxLength"
        :placeholder="$t('ProjectManagement.commitments.doneDialog.commentPlaceholder')"
        data-testid="commitment-done-comment"
      />
      <small class="text-[var(--color-disabled)]">
        {{ $t('ProjectManagement.commitments.doneDialog.optionalHint') }}
      </small>
    </label>

    <template #footer>
      <Button
        :label="$t('ProjectManagement.cancel')"
        severity="secondary"
        text
        data-testid="commitment-done-cancel"
        @click="close"
      />
      <Button
        :label="$t('ProjectManagement.commitments.doneDialog.submit')"
        :loading="loading"
        class="btn-primary-accent"
        unstyled
        data-testid="commitment-done-submit"
        @click="submit"
      />
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Textarea from 'primevue/textarea';

const MAX_LENGTH = 500;

export default {
  name: 'CommitmentDoneDialog',
  components: {
    Dialog,
    Button,
    Textarea,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    commitmentLabel: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:visible', 'submit'],
  data() {
    return {
      comment: '',
      maxLength: MAX_LENGTH,
    };
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
  },
  methods: {
    close() {
      this.visibleProxy = false;
    },
    resetForm() {
      this.comment = '';
    },
    submit() {
      this.$emit('submit', {
        completionComment: this.comment.trim() || undefined,
      });
    },
  },
};
</script>
